<template>
  <div>
    <!-- Items -->
    <div v-for="(item, index) in items" :key="index" >
      <div class="cart-summary-item cart-summary-product">
        <a :href="item.extra.url" class="flex-1 flex flex-col min-w-0">
          <span class="cart-summary-item__title">{{ item.description }}</span>
          <span class="cart-summary-item__price">USD {{ item.price.toFixed(2) }}</span>
        </a>
        <i class="fas fa-times ml-2 cursor-pointer text-sm" @click="removeItem(index)"></i>
      </div>
      <div v-if="item.extra.regionName !== PBE">
        <div v-if="item.extra.withRecoveryDetails">
          <div class="cart-summary-item cart-summary-product-2 ml-20">
            <div class="flex-1 flex flex-col min-w-0">
              <span class="cart-summary-item__title">Recovery Details</span>
              <span class="cart-summary-item__price">USD 5.00</span>
            </div>
            <i class="fas fa-info-circle ml-2 cursor-pointer text-sm" data-tippy-content="The following will be provided: Original region, Country of creation, Creation date, First skin purchased, First 5 champions, First champion at each price range."></i>
            <i class="fas fa-times ml-2 cursor-pointer text-sm" @click="setWithRecoveryDetails(index, item, false)"></i>
          </div>
        </div>
        <div v-else>
          <div class="cart-summary-item cart-summary-recovery ml-20 pt-1 pb-1">
            <div class="flex-1 flex flex-col min-w-0">
              <span>
                Get full Recovery Details for only $5!
                <i class="fas fa-info-circle ml-2 cursor-pointer text-sm" data-tippy-content="The following will be provided: Original region, Country of creation, Creation date, First skin purchased, First 5 champions, First champion at each price range."></i>
              </span>
            </div>
            <a class="simple-btn btn-ghost btn-green" @click="setWithRecoveryDetails(index, item, true)">
              <span class="btn-content text-sm">Add</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Warranty card -->
    <div v-if="!empty" class="cart-summary-item cart-summary-warranty">
      <div class="flex flex-col">
        <span class="cart-summary-item__title">Free Lifetime Warranty</span>
        <span class="cart-summary-item__price">FREE</span>
      </div>
    </div>

    <!-- Applied coupon -->
    <div v-if="hasAppliedCoupon && !empty" class="cart-summary-item cart-summary-coupon">
      <div class="flex flex-col">
        <span class="cart-summary-item__title">Coupon: {{ coupon }}</span>
        <span
          class="cart-summary-item__price"
        >{{ discount ? `USD -${discount.toFixed(2)}` : `N/A` }}</span>
      </div>
      <i class="fas fa-times ml-2 cursor-pointer text-sm" @click="removeCoupon()"></i>
    </div>

    <!-- Empty state -->
    <div v-if="empty" class="cart-summary-item cart-summary-warranty">
      <div class="flex flex-col">
        <span class="cart-summary-item__title">Your Cart is Empty</span>
        <span class="cart-summary-item__price">Like the soul of a Yasuo main</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import { isNil } from 'lodash';
import tippy from 'tippy.js';
import { regionsNames } from '../constants/region-name';

const PBE = regionsNames.PBE;

export default {
  data() {
    return {
      PBE,
    };
  },

  computed: {
    ...mapState('cart', ['items', 'coupon', 'discount']),
    ...mapGetters('cart', ['total', 'empty']),

    hasAppliedCoupon() {
      return !isNil(this.coupon) && !isNil(this.discount);
    },
  },

  mounted() {
    tippy('[data-tippy-content]');
  },

  updated() {
    tippy('[data-tippy-content]');
  },

  methods: {
    ...mapActions('cart', ['removeItem', 'updateItem']),
    ...mapMutations('cart', ['removeCoupon']),

    setWithRecoveryDetails(index, item, withRecoveryDetails = false) {
      let { description, price, extra } = item;

      this.updateItem({
        index,
        item: {
          description,
          price,
          extra: {
            ...extra,
            withRecoveryDetails,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-summary-item {
  @apply flex justify-between items-center;
  @apply bg-almost-black-light border border-50;
  @apply font-bold;
  @apply px-4 mb-3;

  background-position: center left;
  background-size: 200px;
  background-repeat: no-repeat;

  &__title {
    @apply text-smurfs-gold font-bold text-md;
    @apply truncate;
  }

  &__price {
    @apply font-normal text-sm;
  }
}

.cart-summary-product,
.cart-summary-product-2,
.cart-summary-warranty,
.cart-summary-coupon {
  background-size: cover;
}

.cart-summary-recovery {
  @apply text-sm;
}

$overlay-color: rgba(24, 24, 24, 0.6);

.cart-summary-product {
  background-image: linear-gradient($overlay-color 0%, $overlay-color 100%),
    url('/images/cart/product.jpg');
}

.cart-summary-product-2 {
  background-image: linear-gradient($overlay-color 0%, $overlay-color 100%),
    url('/images/cart/product-2.png');
}

.cart-summary-warranty {
  background-image: linear-gradient($overlay-color 0%, $overlay-color 100%),
    url('/images/cart/lifetime.jpg');
}

.cart-summary-coupon {
  background-image: linear-gradient($overlay-color 0%, $overlay-color 100%),
    url('/images/cart/coupon.jpg');
}
</style>
